/**
 * Кратък етикет/заглавие на корица — ЕДИН източник на истина за целия сайт.
 *
 * Приоритет: `seoH1` (от Finalcover xlsx) → старото кратко `description` (преходно:
 * преди импорта description е краткият етикет; след импорта става дълъг текст, затова
 * го ползваме само ако е ≤120 знака) → `{name} – корица N` → `Корица N`.
 *
 * @param {{ seoH1?: string|null, description?: string|null }} template
 * @param {number} index — позиция (0-базиран)
 * @param {string} [destinationName]
 * @returns {string}
 */
const MAX_LABEL_FROM_DESCRIPTION = 120;

export function coverLabel(template, index, destinationName) {
  const h1 = typeof template?.seoH1 === 'string' ? template.seoH1.trim() : '';
  if (h1) {
    return h1;
  }
  const desc = typeof template?.description === 'string' ? template.description.trim() : '';
  if (desc && desc.length <= MAX_LABEL_FROM_DESCRIPTION) {
    return desc;
  }
  const base = typeof destinationName === 'string' ? destinationName.trim() : '';
  return base ? `${base} – корица ${index + 1}` : `Корица ${index + 1}`;
}
